import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }


export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementAmountTotal',
  props: {
    totalAmount: {},
    count: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" Disb Amount: " + _toDisplayString(__props.totalAmount) + " ", 1),
    (__props.count > 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(__props.count) + " items)", 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})